import { css, LitElement, html } from 'lit-element';
import { sy_arrow_chevron_right, sy_arrow_arrow_right, sy_arrow_chevron_leftlarge } from '@aab/sc-aab-icon-set';
import { unsafeSVG } from 'lit-html/directives/unsafe-svg';

var css_248z = css`/* Utilities */
.d-flex {
  display: flex !important;
}

.flex-row {
  -ms-flex-direction: row !important;
  flex-direction: row !important;
}

.flex-row-reverse {
  -ms-flex-direction: row-reverse !important;
  flex-direction: row-reverse !important;
}

.position-absolute {
  position: absolute !important;
}

.position-relative {
  position: relative !important;
}

.spb-1 {
  padding-bottom: 4px !important;
}

a {
  color: #00716b;
  text-decoration: none;
  /* NO ICON LINK STYLES */
  /* ICON LINK STYLES */
  /* MOVING ICON */
}
a svg path {
  color: #00716b;
}
a:hover {
  color: #00857a;
}
a:hover svg path {
  fill: #00857a;
}
a.inline {
  text-decoration: underline;
  text-decoration-color: #c0d1d0;
  text-underline-offset: 2px;
  display: inline;
}
a.inline:hover {
  color: #37aba1;
  text-decoration-color: #37aba1;
}
a.inline:active, a.inline:focus {
  text-decoration-color: #00716b;
  color: #00716b;
}
a.inline:visited {
  text-decoration-color: #c0d1d0;
}
a.inline.inverted {
  color: #edf7f7;
  text-decoration-color: #d3e0e0;
}
a.inline.inverted:hover {
  text-decoration-color: #ade0df;
}
a.inline.inverted:active, a.inline.inverted:focus {
  text-decoration-color: #edf7f7;
  color: #edf7f7;
}
a.inline.inverted :visited {
  color: #edf7f7;
  text-decoration-color: #d3e0e0;
}
a.inverted {
  color: #edf7f7;
}
a.inverted svg path {
  fill: #edf7f7;
}
a.inverted:hover {
  color: #ade0df;
}
a.inverted:hover svg path {
  fill: #ade0df;
}
a .moving-icon {
  width: 24px;
  height: 24px;
  display: inline-block;
}
a .moving-icon svg {
  width: 24px;
  display: inline-block;
  -webkit-transition: margin 0.15s;
  /* Safari */
  transition: margin 0.15s;
}
a .moving-icon.back, a .moving-icon.list {
  padding-right: 4px;
}
a:hover .moving-icon.back svg, a:focus .moving-icon.back svg {
  margin-left: -4px;
}
a:hover .moving-icon.list svg, a:hover .moving-icon.single svg, a:focus .moving-icon.list svg, a:focus .moving-icon.single svg {
  margin-left: 4px;
}
a ::slotted(*),
a slot {
  line-height: 24px;
  display: inline;
}`;

const LEFT_ICONS = {
  list: sy_arrow_arrow_right,
  back: sy_arrow_chevron_leftlarge,
};

class AabLink extends LitElement {
  static get properties() {
    return {
      target: { type: String },
      url: { type: String },
      type: { type: String },
      inverted: { type: Boolean },
    };
  }

  static get styles() {
    return [css_248z];
  }

  constructor() {
    super();
    this.target = '_self';
    this.url = '#';
    this.type = 'inline';
  }

  /**
 * Renders the icon for the link type
 * @method renderIconByType
 * @param {string} type - The position of the icon that needs to be rendered.
 * @return {html} - Returns the type of the link that needs to be rendered
 * which can be left, right or no icon
*/
  renderIconByType(type) {
    switch (type) {
      case 'single':
        return this.renderRightIcon();
      case 'list':
        return this.renderLeftIcon();
      case 'back':
        return this.renderLeftIcon();
      default:
        return html`<slot></slot>`;
    }
  }

  /**
 * HTML class for the anchor tag
 * @method renderClassbyType
 * @returns {htmlClass} - Returns the class name based on the type
 */
  renderClassbyType(type) {
    switch (type) {
      case 'inline':
        return 'inline';
      case 'list':
        return 'd-flex';
      default:
        return 'd-flex spb-1';
    }
  }

  /**
 * HTML template for the left icon.
 * @method renderLeftIcon
 * @return {html} - Returns the HTML template for a left sided icon
 */
  renderLeftIcon() {
    return html`
    <div class="d-flex flex-row">
      <span class="moving-icon left ${this.type}">
        ${unsafeSVG(LEFT_ICONS[this.type])}
      </span>
      <slot></slot>
    </div>
    `;
  }

  /**
 * HTML template for the right icon.
 * @method renderRightIcon
 * @return {html} - Returns the HTML template for a right sided icon
 */
  renderRightIcon() {
    return html`
    <div class="d-flex flex-row-reverse">
      <span class="moving-icon right ${this.type}">
        ${unsafeSVG(sy_arrow_chevron_right)}
      </span>
      <slot></slot>
    </div>
    `;
  }

  render() {
    return html`
      <a
        class="${this.renderClassbyType(this.type)} ${this.inverted ? 'inverted' : ''}"
        href=${this.url}
        target=${this.target}
        rel="noopener"
      >
        ${this.renderIconByType(this.type)}
      </a>
    `;
  }
}

export { AabLink as default };
